import React, {
  useState,
  useEffect,
  // useCallback,
  useRef,
} from 'react'
import { Checkbox, Button } from '@mantine/core'
import addEventListener from 'rc-util/lib/Dom/addEventListener'
import getFixScaleEleTransPosition from '../hooks/getFixScaleEleTransPosition'
import Mark from '../Mark'

const initialPosition = {
  x: 0,
  y: 0,
}

const getAttachmentSrc = (originSrc = '') => {
  const target = originSrc.replace(/filters:/, 'filters:attachment():')
  return target
}

const Preview = (props) => {
  const {
    // prefixCls,
    src,
    srcWatermark, // 添加水印的链接
    alt,
    // onClose,
    // afterClose,
    scaleStep = 0.5,
    currentFile,
    isShowWatermark,
    showWatermark,
    updateImg,
    isMark,
    setIsMark,
    setIsLoading,
    // ...restProps
  } = props

  // const [isLoading, setIsLoading] = useState(false)
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)
  const [position, setPosition] = useState(initialPosition)
  const imgRef = useRef()
  const [downloadUrl, setDownloadUrl] = useState('')
  const originPositionRef = useRef({
    originX: 0,
    originY: 0,
    deltaX: 0,
    deltaY: 0,
  })
  const [isMoving, setMoving] = useState(false)
  // const combinationSrc = src
  const [lastWheelZoomDirection, setLastWheelZoomDirection] = useState({
    wheelDirection: 0,
  })

  const onAfterClose = () => {
    setScale(1)
    setRotate(0)
    setPosition(initialPosition)
  }

  const onZoomIn = () => {
    setScale(scale + scaleStep)
    setPosition(initialPosition)
  }

  const onZoomOut = () => {
    if (scale > 1) {
      setScale(scale - scaleStep)
    }
    setPosition(initialPosition)
  }

  const onRotateRight = () => {
    setRotate(rotate + 90)
  }

  const onRotateLeft = () => {
    setRotate(rotate - 90)
  }

  const onImageMark = () => {
    setIsMark(true)
  }

  const tools = [
    {
      Icon: (
        <svg
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="rotate-left"
          width="20px"
          height="20px"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" />
          <path d="M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" />
        </svg>
      ),
      onClick: onRotateLeft,
      type: 'rotateLeft',
      name: '左旋',
    },
    {
      Icon: (
        <svg
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="rotate-right"
          width="20px"
          height="20px"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" />
          <path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" />
        </svg>
      ),
      onClick: onRotateRight,
      type: 'rotateRight',
      name: '右旋',
    },
    {
      Icon: (
        <svg
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="zoom-in"
          width="20px"
          height="20px"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" />
        </svg>
      ),
      onClick: onZoomIn,
      type: 'zoomIn',
      name: '放大',
    },
    {
      Icon: (
        <svg
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="zoom-out"
          width="20px"
          height="20px"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" />
        </svg>
      ),
      onClick: onZoomOut,
      type: 'zoomOut',
      disabled: scale === 1,
      name: '缩小',
    },
  ]

  // 鼠标停止拖动
  const onMouseUp = () => {
    if (isMoving) {
      // 图片容器的宽高
      const width = imgRef.current.offsetWidth * scale
      const height = imgRef.current.offsetHeight * scale
      const pos = imgRef.current.getBoundingClientRect()
      const { left, top } = pos
      const isRotate = rotate % 180 !== 0

      setMoving(false)

      const finalHeight = isRotate ? height : width
      const finalWidth = isRotate ? width : height
      const fixState = getFixScaleEleTransPosition(
        finalHeight,
        finalWidth,
        left,
        top
      )
      const absLeft = Math.abs(left)
      const absTop = Math.abs(top)
      if (
        (fixState.x || fixState.y) &&
        absLeft < finalWidth &&
        absTop < finalHeight
      ) {
        setPosition({ ...fixState })
      } else {
        setPosition({ x: 0, y: 0 })
      }
    }
  }

  // 鼠标开始拖动
  const onMouseDown = (event) => {
    // Only allow main button
    if (event.button !== 0) return
    event.preventDefault()
    // Without this mask close will abnormal
    event.stopPropagation()
    originPositionRef.current.deltaX = event.pageX - position.x
    originPositionRef.current.deltaY = event.pageY - position.y
    originPositionRef.current.originX = position.x
    originPositionRef.current.originY = position.y
    setMoving(true)
  }

  // 鼠标移动
  const onMouseMove = (event) => {
    if (isMoving) {
      setPosition({
        x: event.pageX - originPositionRef.current.deltaX || event.pageX,
        y: event.pageY - originPositionRef.current.deltaY || event.pageY,
      })
    }
  }

  const onWheelMove = (event) => {
    event.preventDefault()
    const wheelDirection = event.deltaY
    setLastWheelZoomDirection({ wheelDirection })
  }

  const onDoubleClick = () => {
    if (scale !== 1) {
      setScale(1)
    }
    if (position.x !== initialPosition.x || position.y !== initialPosition.y) {
      setPosition(initialPosition)
    }
  }

  useEffect(() => {
    onAfterClose()
    // showWatermark(false)
  }, [currentFile])

  // 鼠标滚动放大缩小
  useEffect(() => {
    const { wheelDirection } = lastWheelZoomDirection
    if (wheelDirection > 0) {
      onZoomOut()
    } else if (wheelDirection < 0) {
      onZoomIn()
    }
  }, [lastWheelZoomDirection])

  // 监听鼠标滑动
  useEffect(() => {
    let onTopMouseUpListener
    let onTopMouseMoveListener

    const onMouseUpListener = addEventListener(
      window,
      'mouseup',
      onMouseUp,
      false
    )
    const onMouseMoveListener = addEventListener(
      window,
      'mousemove',
      onMouseMove,
      false
    )
    const onScrollWheelListener = addEventListener(
      window,
      'wheel',
      onWheelMove,
      {
        passive: false,
      }
    )

    try {
      // Resolve if in iframe lost event
      /* istanbul ignore next */
      if (window.top !== window.self) {
        onTopMouseUpListener = addEventListener(
          window.top,
          'mouseup',
          onMouseUp,
          false
        )
        onTopMouseMoveListener = addEventListener(
          window.top,
          'mousemove',
          onMouseMove,
          false
        )
      }
    } catch (error) {
      /* istanbul ignore next */
    }

    return () => {
      onMouseUpListener.remove()
      onMouseMoveListener.remove()
      onScrollWheelListener.remove()

      /* istanbul ignore next */
      if (onTopMouseUpListener) onTopMouseUpListener.remove()
      /* istanbul ignore next */
      if (onTopMouseMoveListener) onTopMouseMoveListener.remove()
    }
  }, [isMoving])

  // 监听水印是否打开
  useEffect(() => {
    let url
    if (isShowWatermark) {
      url = getAttachmentSrc(srcWatermark)
    } else {
      url = src
    }
    url += `${
      url.includes('?') ? '&' : '?'
    }response-content-type=application/octet-stream&t=${Date.now()}`
    setDownloadUrl(url)
  }, [isShowWatermark])

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        minWidth: '100vw',
        minHeight: '100vh',
      }}
      className="flex items-center justify-center"
    >
      <div
        className="flex gap-10 items-center justify-center absolute rounded-md px-5 text-white"
        style={{
          top: '-96px',
          height: '64px',
          zIndex: '9997',
        }}
      >
        {tools.map(({ onClick, type, disabled, Icon }) => (
          <div
            className="cursor-pointer"
            onClick={disabled ? null : onClick}
            key={type}
          >
            {Icon}
          </div>
        ))}
        <Checkbox
          label="添加水印"
          styles={{ label: { color: '#fff' } }}
          checked={isShowWatermark}
          onChange={(e) => {
            showWatermark(e.target.checked)
          }}
        />
        <Button type="primary">
          <a
            target="_blank"
            rel="noreferrer"
            download={Date.now()}
            href={downloadUrl}
          >
            下载图片
          </a>
        </Button>
        <Button
          type="primary"
          onClick={() => {
            window.open(isShowWatermark ? currentFile.originWatermarkUrl : src)
          }}
        >
          查看原图
        </Button>
        <Button type="primary" onClick={onImageMark}>
          标注
        </Button>
      </div>

      {!isMark ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
            // pointerEvents: 'none',
            userSelect: 'none',
          }}
          className="flex items-center justify-center"
        >
          <div
            onMouseDown={onMouseDown}
            onDoubleClick={onDoubleClick}
            ref={imgRef}
            style={{
              maxHeight: '70%',
              height: '70%',
              position: 'relative',
              transform: `scale3d(${scale}, ${scale}, 1) rotate(${rotate}deg)`,
            }}
            id="markContainer"
            className="flex items-center justify-center"
          >
            <img
              id="img"
              src={
                isShowWatermark
                  ? srcWatermark
                  : `${src}?x-oss-process=image${
                      src.indexOf('.jpg') > -1 ? '' : '/format,jpg'
                    }/quality,Q_20`
              }
              alt={alt}
              style={{
                height: '100%',
                width: 'auto',
                // pointerEvents: 'none',
                // userSelect: 'none',
              }}
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            userSelect: 'none',
          }}
          className="flex items-center justify-center"
        >
          <div
            style={{
              maxHeight: '70%',
              height: '70%',
            }}
            id="markContainer2"
            className="flex flex-col items-center justify-center"
          >
            <Mark
              currentFile={currentFile}
              isShowWatermark={isShowWatermark}
              src={src}
              updateImg={updateImg}
              onCancle={() => {
                setIsMark(false)
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Preview
